import type { PartialStoreState } from '../typings'

export const selectTrafficTimeWindows = (state: PartialStoreState) =>
  state.domain.publicData.domain.rm.traffic.timeWindows

export const selectTrafficProfiles = (state: PartialStoreState) =>
  state.domain.publicData.domain.rm.traffic.profiles
